// @ts-check

import {
  UPLOAD_ASSET
} from './actionTypes';
import { getActionStatusName } from '@/store/helpers';
export const getUploadAssetStatus = state => state.status[getActionStatusName(UPLOAD_ASSET)] || {};
